import axios from "axios";

// Fully separate from utils/api.js's `api` — a different token (trackin_driver_token,
// never the org's trackin_token), and a different 401 destination (the driver login,
// never /auth), so an owner and a driver session in the same browser never collide.
const BASE_URL = process.env.REACT_APP_API_URL || "";

const driverApi = axios.create({ baseURL: BASE_URL, timeout: 15000 });

driverApi.interceptors.request.use(config => {
  const token = localStorage.getItem("trackin_driver_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

driverApi.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem("trackin_driver_token");
      localStorage.removeItem("trackin_driver");
      window.location.href = "/driver-app";
    }
    const msg = err.response?.data?.error || err.message || "Request failed";
    const error = new Error(msg);
    error.status = err.response?.status;
    return Promise.reject(error);
  }
);

export default driverApi;
